import { render, staticRenderFns } from "./Yonazuku3d.vue?vue&type=template&id=0415ecd1&scoped=true&"
import script from "./Yonazuku3d.vue?vue&type=script&lang=js&"
export * from "./Yonazuku3d.vue?vue&type=script&lang=js&"
import style0 from "./Yonazuku3d.vue?vue&type=style&index=0&id=0415ecd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0415ecd1",
  null
  
)

export default component.exports